import * as Yup from "yup";

export const pendingPaymentSchema = Yup.object({

 
    gender1: Yup.string().required("Please Select Payment"),
    // customerName: Yup.string().required("Please Select Payment"),


});